{
 "_readme": "English names for iranGeo.json, keyed by the stored Persian value. Display only: the value saved on a clinic stays the Persian string.",
 "names": {
  "آذربایجان شرقی": "East Azerbaijan",
  "تبریز": "Tabriz",
  "مراغه": "Maragheh",
  "مرند": "Marand",
  "اهر": "Ahar",
  "بناب": "Bonab",
  "میانه": "Mianeh",
  "شبستر": "Shabestar",
  "سراب": "Sarab",
  "آذرشهر": "Azarshahr",
  "اسکو": "Osku",
  "بستان‌آباد": "Bostanabad",
  "جلفا": "Jolfa",
  "عجب‌شیر": "Ajabshir",
  "کلیبر": "Kaleybar",
  "ملکان": "Malekan",
  "ورزقان": "Varzaqan",
  "هریس": "Heris",
  "هشترود": "Hashtrud",
  "خداآفرین": "Khoda Afarin",
  "چاراویماق": "Charuymaq",
  "آذربایجان غربی": "West Azerbaijan",
  "ارومیه": "Urmia",
  "خوی": "Khoy",
  "میاندوآب": "Miandoab",
  "مهاباد": "Mahabad",
  "بوکان": "Bukan",
  "سلماس": "Salmas",
  "نقده": "Naqadeh",
  "پیرانشهر": "Piranshahr",
  "سردشت": "Sardasht",
  "ماکو": "Maku",
  "شاهین‌دژ": "Shahin Dezh",
  "تکاب": "Takab",
  "اشنویه": "Oshnavieh",
  "چالدران": "Chaldoran",
  "پلدشت": "Poldasht",
  "چایپاره": "Chaypareh",
  "شوط": "Showt",
  "اردبیل": "Ardabil",
  "پارس‌آباد": "Parsabad",
  "مشگین‌شهر": "Meshginshahr",
  "خلخال": "Khalkhal",
  "گرمی": "Germi",
  "بیله‌سوار": "Bileh Savar",
  "نمین": "Namin",
  "نیر": "Nir",
  "کوثر": "Kowsar",
  "سرعین": "Sareyn",
  "اصفهان": "Isfahan",
  "کاشان": "Kashan",
  "خمینی‌شهر": "Khomeini Shahr",
  "نجف‌آباد": "Najafabad",
  "شاهین‌شهر": "Shahin Shahr",
  "شهرضا": "Shahreza",
  "فلاورجان": "Falavarjan",
  "مبارکه": "Mobarakeh",
  "گلپایگان": "Golpayegan",
  "نطنز": "Natanz",
  "اردستان": "Ardestan",
  "سمیرم": "Semirom",
  "زرین‌شهر": "Zarrin Shahr",
  "تیران": "Tiran",
  "دهاقان": "Dehaqan",
  "خوانسار": "Khansar",
  "فریدن": "Fereydan",
  "فریدون‌شهر": "Fereydunshahr",
  "چادگان": "Chadegan",
  "بویین و میاندشت": "Buin and Miandasht",
  "نائین": "Nain",
  "آران و بیدگل": "Aran and Bidgol",
  "دولت‌آباد": "Dolatabad",
  "خور": "Khur",
  "البرز": "Alborz",
  "کرج": "Karaj",
  "فردیس": "Fardis",
  "نظرآباد": "Nazarabad",
  "هشتگرد": "Hashtgerd",
  "اشتهارد": "Eshtehard",
  "طالقان": "Taleqan",
  "چهارباغ": "Chaharbagh",
  "ماهدشت": "Mahdasht",
  "محمدشهر": "Mohammadshahr",
  "مشکین‌دشت": "Meshkin Dasht",
  "ایلام": "Ilam",
  "دهلران": "Dehloran",
  "آبدانان": "Abdanan",
  "مهران": "Mehran",
  "ایوان": "Eyvan",
  "دره‌شهر": "Darreh Shahr",
  "سرابله": "Sarableh",
  "بدره": "Badreh",
  "ارکواز": "Arkavaz",
  "چوار": "Chavar",
  "هلیلان": "Holeylan",
  "بوشهر": "Bushehr",
  "برازجان": "Borazjan",
  "گناوه": "Genaveh",
  "دیلم": "Deylam",
  "خورموج": "Khormuj",
  "اهرم": "Ahram",
  "جم": "Jam",
  "کنگان": "Kangan",
  "عسلویه": "Asaluyeh",
  "دیر": "Deyr",
  "بندر ریگ": "Bandar Rig",
  "تهران": "Tehran",
  "اسلامشهر": "Eslamshahr",
  "شهریار": "Shahriar",
  "ری": "Rey",
  "ورامین": "Varamin",
  "پاکدشت": "Pakdasht",
  "رباط‌کریم": "Robat Karim",
  "قدس": "Qods",
  "ملارد": "Malard",
  "قرچک": "Qarchak",
  "پردیس": "Pardis",
  "دماوند": "Damavand",
  "فیروزکوه": "Firuzkuh",
  "پیشوا": "Pishva",
  "بهارستان": "Baharestan",
  "تجریش": "Tajrish",
  "باقرشهر": "Baqershahr",
  "چهاردانگه": "Chahardangeh",
  "نسیم‌شهر": "Nasimshahr",
  "اندیشه": "Andisheh",
  "لواسان": "Lavasan",
  "رودهن": "Rudehen",
  "بومهن": "Bumehen",
  "حسن‌آباد": "Hasanabad",
  "چهارمحال و بختیاری": "Chaharmahal and Bakhtiari",
  "شهرکرد": "Shahrekord",
  "بروجن": "Borujen",
  "لردگان": "Lordegan",
  "فارسان": "Farsan",
  "اردل": "Ardal",
  "شلمزار": "Shalamzar",
  "چلگرد": "Chelgerd",
  "بن": "Ben",
  "سامان": "Saman",
  "خانمیرزا": "Khanmirza",
  "خراسان جنوبی": "South Khorasan",
  "بیرجند": "Birjand",
  "قائن": "Qaen",
  "فردوس": "Ferdows",
  "طبس": "Tabas",
  "نهبندان": "Nehbandan",
  "سرایان": "Sarayan",
  "بشرویه": "Boshruyeh",
  "درمیان": "Darmian",
  "خوسف": "Khusf",
  "زیرکوه": "Zirkuh",
  "سربیشه": "Sarbisheh",
  "خراسان رضوی": "Razavi Khorasan",
  "مشهد": "Mashhad",
  "نیشابور": "Neyshabur",
  "سبزوار": "Sabzevar",
  "تربت حیدریه": "Torbat-e Heydarieh",
  "تربت جام": "Torbat-e Jam",
  "قوچان": "Quchan",
  "کاشمر": "Kashmar",
  "گناباد": "Gonabad",
  "چناران": "Chenaran",
  "فریمان": "Fariman",
  "خواف": "Khaf",
  "سرخس": "Sarakhs",
  "تایباد": "Taybad",
  "درگز": "Dargaz",
  "بردسکن": "Bardaskan",
  "رشتخوار": "Roshtkhar",
  "فیض‌آباد": "Feyzabad",
  "خلیل‌آباد": "Khalilabad",
  "جوین": "Joveyn",
  "جغتای": "Joghatai",
  "داورزن": "Davarzan",
  "زاوه": "Zaveh",
  "باخرز": "Bakharz",
  "بجستان": "Bajestan",
  "کلات": "Kalat",
  "طرقبه": "Torqabeh",
  "شاندیز": "Shandiz",
  "فیروزه": "Firuzeh",
  "صالح‌آباد": "Salehabad",
  "خراسان شمالی": "North Khorasan",
  "بجنورد": "Bojnurd",
  "شیروان": "Shirvan",
  "اسفراین": "Esfarayen",
  "آشخانه": "Ashkhaneh",
  "جاجرم": "Jajarm",
  "گرمه": "Garmeh",
  "فاروج": "Faruj",
  "راز": "Raz",
  "خوزستان": "Khuzestan",
  "اهواز": "Ahvaz",
  "دزفول": "Dezful",
  "آبادان": "Abadan",
  "خرمشهر": "Khorramshahr",
  "اندیمشک": "Andimeshk",
  "بهبهان": "Behbahan",
  "بندر ماهشهر": "Bandar Mahshahr",
  "شوشتر": "Shushtar",
  "ایذه": "Izeh",
  "شوش": "Shush",
  "مسجدسلیمان": "Masjed Soleyman",
  "رامهرمز": "Ramhormoz",
  "سوسنگرد": "Susangerd",
  "بستان": "Bostan",
  "هندیجان": "Hendijan",
  "امیدیه": "Omidiyeh",
  "باغملک": "Baghmalek",
  "لالی": "Lali",
  "اندیکا": "Andika",
  "گتوند": "Gotvand",
  "هفتکل": "Haftkel",
  "آغاجاری": "Aghajari",
  "رامشیر": "Ramshir",
  "حمیدیه": "Hamidiyeh",
  "شادگان": "Shadegan",
  "هویزه": "Hoveyzeh",
  "دهدز": "Dehdez",
  "زنجان": "Zanjan",
  "ابهر": "Abhar",
  "خرمدره": "Khorramdarreh",
  "قیدار": "Qeydar",
  "ماهنشان": "Mahneshan",
  "آب‌بر": "Ab Bar",
  "زرین‌آباد": "Zarrinabad",
  "سلطانیه": "Soltaniyeh",
  "سمنان": "Semnan",
  "شاهرود": "Shahrud",
  "دامغان": "Damghan",
  "گرمسار": "Garmsar",
  "مهدی‌شهر": "Mahdishahr",
  "سرخه": "Sorkheh",
  "آرادان": "Aradan",
  "میامی": "Miami",
  "بسطام": "Bastam",
  "سیستان و بلوچستان": "Sistan and Baluchestan",
  "زاهدان": "Zahedan",
  "زابل": "Zabol",
  "چابهار": "Chabahar",
  "ایرانشهر": "Iranshahr",
  "سراوان": "Saravan",
  "خاش": "Khash",
  "نیک‌شهر": "Nikshahr",
  "کنارک": "Konarak",
  "راسک": "Rask",
  "دلگان": "Dalgan",
  "مهرستان": "Mehrestan",
  "فنوج": "Fanuj",
  "قصرقند": "Qasr-e Qand",
  "زهک": "Zahak",
  "هیرمند": "Hirmand",
  "بمپور": "Bampur",
  "میرجاوه": "Mirjaveh",
  "سوران": "Suran",
  "فارس": "Fars",
  "شیراز": "Shiraz",
  "مرودشت": "Marvdasht",
  "جهرم": "Jahrom",
  "فسا": "Fasa",
  "کازرون": "Kazerun",
  "لار": "Lar",
  "داراب": "Darab",
  "فیروزآباد": "Firuzabad",
  "نی‌ریز": "Neyriz",
  "اقلید": "Eqlid",
  "آباده": "Abadeh",
  "لامرد": "Lamerd",
  "استهبان": "Estahban",
  "سپیدان": "Sepidan",
  "نورآباد": "Nurabad",
  "زرین‌دشت": "Zarrin Dasht",
  "خرامه": "Kharameh",
  "سروستان": "Sarvestan",
  "کوار": "Kavar",
  "ارسنجان": "Arsanjan",
  "بوانات": "Bavanat",
  "خنج": "Khonj",
  "فراشبند": "Farashband",
  "قیر": "Qir",
  "گراش": "Gerash",
  "مهر": "Mohr",
  "پاسارگاد": "Pasargad",
  "بیضا": "Beyza",
  "صفاشهر": "Safashahr",
  "اوز": "Evaz",
  "قزوین": "Qazvin",
  "تاکستان": "Takestan",
  "الوند": "Alvand",
  "آبیک": "Abyek",
  "بوئین‌زهرا": "Buin Zahra",
  "محمدیه": "Mohammadiyeh",
  "آوج": "Avaj",
  "اقبالیه": "Eqbaliyeh",
  "شال": "Shal",
  "دانسفهان": "Danesfahan",
  "قم": "Qom",
  "جعفریه": "Jafariyeh",
  "کهک": "Kahak",
  "سلفچگان": "Salafchegan",
  "دستجرد": "Dastjerd",
  "قنوات": "Qanavat",
  "کردستان": "Kurdistan",
  "سنندج": "Sanandaj",
  "سقز": "Saqqez",
  "مریوان": "Marivan",
  "بانه": "Baneh",
  "قروه": "Qorveh",
  "بیجار": "Bijar",
  "کامیاران": "Kamyaran",
  "دیواندره": "Divandarreh",
  "دهگلان": "Dehgolan",
  "سروآباد": "Sarvabad",
  "کرمان": "Kerman",
  "سیرجان": "Sirjan",
  "رفسنجان": "Rafsanjan",
  "جیرفت": "Jiroft",
  "بم": "Bam",
  "زرند": "Zarand",
  "شهربابک": "Shahr-e Babak",
  "بردسیر": "Bardsir",
  "بافت": "Baft",
  "کهنوج": "Kahnuj",
  "راور": "Ravar",
  "انار": "Anar",
  "رابر": "Rabor",
  "ارزوئیه": "Arzuiyeh",
  "عنبرآباد": "Anbarabad",
  "فهرج": "Fahraj",
  "قلعه‌گنج": "Qaleh Ganj",
  "منوجان": "Manujan",
  "نرماشیر": "Narmashir",
  "ریگان": "Rigan",
  "کوهبنان": "Kuhbanan",
  "رودبار جنوب": "Rudbar-e Jonubi",
  "کرمانشاه": "Kermanshah",
  "اسلام‌آباد غرب": "Eslamabad-e Gharb",
  "سرپل ذهاب": "Sarpol-e Zahab",
  "کنگاور": "Kangavar",
  "هرسین": "Harsin",
  "جوانرود": "Javanrud",
  "سنقر": "Sonqor",
  "پاوه": "Paveh",
  "صحنه": "Sahneh",
  "گیلانغرب": "Gilan-e Gharb",
  "قصرشیرین": "Qasr-e Shirin",
  "روانسر": "Ravansar",
  "دالاهو": "Dalahu",
  "ثلاث باباجانی": "Salas-e Babajani",
  "کهگیلویه و بویراحمد": "Kohgiluyeh and Boyer-Ahmad",
  "یاسوج": "Yasuj",
  "دوگنبدان": "Dogonbadan",
  "دهدشت": "Dehdasht",
  "لیکک": "Likak",
  "سی‌سخت": "Sisakht",
  "چرام": "Charam",
  "لنده": "Landeh",
  "باشت": "Basht",
  "مارگون": "Margun",
  "گلستان": "Golestan",
  "گرگان": "Gorgan",
  "گنبد کاووس": "Gonbad-e Kavus",
  "علی‌آباد کتول": "Aliabad-e Katul",
  "آق‌قلا": "Aqqala",
  "کردکوی": "Kordkuy",
  "بندر ترکمن": "Bandar Torkaman",
  "مینودشت": "Minudasht",
  "آزادشهر": "Azadshahr",
  "رامیان": "Ramian",
  "کلاله": "Kalaleh",
  "گمیشان": "Gomishan",
  "گالیکش": "Galikesh",
  "مراوه‌تپه": "Maraveh Tappeh",
  "بندر گز": "Bandar Gaz",
  "گیلان": "Gilan",
  "رشت": "Rasht",
  "بندر انزلی": "Bandar Anzali",
  "لاهیجان": "Lahijan",
  "لنگرود": "Langarud",
  "آستارا": "Astara",
  "هشتپر": "Hashtpar",
  "صومعه‌سرا": "Sowme'eh Sara",
  "فومن": "Fuman",
  "رودسر": "Rudsar",
  "آستانه اشرفیه": "Astaneh-ye Ashrafiyeh",
  "رودبار": "Rudbar",
  "ماسال": "Masal",
  "شفت": "Shaft",
  "سیاهکل": "Siahkal",
  "املش": "Amlash",
  "رضوانشهر": "Rezvanshahr",
  "لرستان": "Lorestan",
  "خرم‌آباد": "Khorramabad",
  "بروجرد": "Borujerd",
  "دورود": "Dorud",
  "الیگودرز": "Aligudarz",
  "کوهدشت": "Kuhdasht",
  "ازنا": "Azna",
  "پلدختر": "Poldokhtar",
  "الشتر": "Aleshtar",
  "رومشکان": "Rumeshkan",
  "چگنی": "Chegeni",
  "مازندران": "Mazandaran",
  "ساری": "Sari",
  "بابل": "Babol",
  "آمل": "Amol",
  "قائم‌شهر": "Qaemshahr",
  "بهشهر": "Behshahr",
  "نوشهر": "Nowshahr",
  "چالوس": "Chalus",
  "تنکابن": "Tonekabon",
  "رامسر": "Ramsar",
  "نور": "Nur",
  "نکا": "Neka",
  "جویبار": "Juybar",
  "پل سفید": "Pol Sefid",
  "فریدون‌کنار": "Fereydunkenar",
  "محمودآباد": "Mahmudabad",
  "بابلسر": "Babolsar",
  "عباس‌آباد": "Abbasabad",
  "گلوگاه": "Galugah",
  "میاندورود": "Miandorud",
  "سیمرغ": "Simorgh",
  "کلاردشت": "Kelardasht",
  "چمستان": "Chamestan",
  "مرکزی": "Markazi",
  "اراک": "Arak",
  "ساوه": "Saveh",
  "خمین": "Khomein",
  "محلات": "Mahallat",
  "دلیجان": "Delijan",
  "شازند": "Shazand",
  "تفرش": "Tafresh",
  "آشتیان": "Ashtian",
  "کمیجان": "Komijan",
  "مأمونیه": "Mamuniyeh",
  "فراهان": "Farahan",
  "خنداب": "Khondab",
  "هرمزگان": "Hormozgan",
  "بندرعباس": "Bandar Abbas",
  "میناب": "Minab",
  "بندر لنگه": "Bandar Lengeh",
  "قشم": "Qeshm",
  "کیش": "Kish",
  "رودان": "Rudan",
  "حاجی‌آباد": "Hajiabad",
  "بستک": "Bastak",
  "پارسیان": "Parsian",
  "جاسک": "Jask",
  "سیریک": "Sirik",
  "بندر خمیر": "Bandar Khamir",
  "ابوموسی": "Abu Musa",
  "همدان": "Hamadan",
  "ملایر": "Malayer",
  "نهاوند": "Nahavand",
  "تویسرکان": "Tuyserkan",
  "اسدآباد": "Asadabad",
  "بهار": "Bahar",
  "کبودرآهنگ": "Kabudarahang",
  "رزن": "Razan",
  "فامنین": "Famenin",
  "درگزین": "Dargazin",
  "یزد": "Yazd",
  "میبد": "Meybod",
  "اردکان": "Ardakan",
  "بافق": "Bafq",
  "مهریز": "Mehriz",
  "ابرکوه": "Abarkuh",
  "تفت": "Taft",
  "اشکذر": "Ashkezar",
  "هرات": "Harat",
  "بهاباد": "Bahabad",
  "مروست": "Marvast"
 }
}